// extracted by mini-css-extract-plugin
module.exports = {"root":"IntroBackground-module__root___9t2fg"};